<div class="project-card" (click)="goProjectDetail()">
  <!-- Imagem inset (como em prod), chanfrada -->
  <div class="project-media">
    <div class="project-frame">
      <div class="project-image" [ngStyle]="{'background-image': imageStyle}"></div>
    </div>
    <span class="star-badge" (click)="$event.stopPropagation(); showConfirm()" *ngIf="!shared"
          [ngClass]="{ 'favorited': project?.favorite }">
      <i class="pi" [ngClass]="project?.favorite ? 'pi-star-fill' : 'pi-star'"></i>
    </span>
  </div>

  <div class="project-info">
    <h3 class="project-title">{{ project?.name }}</h3>

    <!-- Linha: dono à esquerda, aplicação (badge de marca) à direita — layout de prod -->
    <div class="project-subrow">
      <span class="project-user">{{ "project.card.myProject" | transloco }}</span>
      <span class="chip chip--accent" *ngFor="let applications of project?.application">{{ applications.name }}</span>
    </div>

    <div class="project-tags">
      <span class="chip" *ngFor="let equipment of project?.equipments">{{ equipment.name }}</span>
      <span class="chip" *ngIf="project?.attributes?.['date-of-manufacture']">{{ project?.attributes?.['date-of-manufacture'] | date: 'yyyy' }}</span>
    </div>

    <div class="project-footer">
      <span class="likes-count tnum">
        <i class="pi pi-heart-fill"></i>
        {{ project?.likes || 0 }}
      </span>
      <span class="go-btn" aria-hidden="true">
        <i class="pi pi-chevron-right"></i>
      </span>
    </div>
  </div>
</div>
